import { Link } from "react-router-dom";
import { Brain, Mail, MapPin, Linkedin, MessageCircle, Phone } from "lucide-react";

// WhatsApp Icon Component
const WhatsAppIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const WHATSAPP_LINK = "https://wa.me/33644692901?text=Bonjour Lucie-IA, je souhaite en savoir plus sur les formations IA.";

  return (
    <footer className="bg-[#0F0F10] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 sm:gap-12">
          {/* Brand */}
          <div className="sm:col-span-2">
            <Link to="/" className="flex items-center gap-3 mb-4 sm:mb-6">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#007AFF] to-[#007AFF]/50 flex items-center justify-center">
                <Brain className="w-5 h-5 text-white" />
              </div>
              <div>
                <span className="text-lg font-bold text-white">Académie</span>
                <span className="text-lg font-bold text-[#007AFF] ml-1">IA</span>
              </div>
            </Link>
            <p className="text-white/60 leading-relaxed max-w-md mb-4 sm:mb-6 text-sm sm:text-base">
              Formez vos équipes à l'Intelligence Artificielle avec des experts 
              pédagogues et charismatiques. Découvrez, expérimentez, transformez.
            </p>
            <div className="flex items-center gap-3 sm:gap-4">
              <a 
                href={WHATSAPP_LINK}
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-2 px-4 py-2 rounded-full bg-green-500/20 text-green-400 hover:bg-green-500/30 hover:scale-105 transition-all text-sm font-semibold"
                data-testid="footer-whatsapp"
              >
                <WhatsAppIcon className="w-5 h-5" />
                Contactez Lucie-IA
                <Phone className="w-3 h-3 animate-pulse" />
              </a>
              <a 
                href="https://linkedin.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-white/60 hover:text-white hover:bg-white/10 transition-colors"
                data-testid="footer-linkedin"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-white font-semibold mb-3 sm:mb-4 text-sm sm:text-base">Navigation</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <Link to="/formations" className="text-white/60 hover:text-white transition-colors text-sm">
                  Formations
                </Link>
              </li>
              <li>
                <Link to="/tunnel" className="text-white/60 hover:text-white transition-colors text-sm">
                  Demander un devis
                </Link>
              </li>
              <li>
                <Link to="/espace-pedagogique" className="text-white/60 hover:text-white transition-colors text-sm">
                  Ressources pédagogiques
                </Link>
              </li>
              <li>
                <Link to="/outils-ia" className="text-white/60 hover:text-white transition-colors text-sm">
                  Outils IA
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-3 sm:mb-4 text-sm sm:text-base">Contact - Lucie-IA</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li className="flex items-center gap-3 text-white/60">
                <Mail className="w-4 h-4 flex-shrink-0" />
                <a href="mailto:lucie@academie-ia.fr" className="hover:text-white transition-colors text-sm">
                  lucie@academie-ia.fr
                </a>
              </li>
              <li className="flex items-center gap-3 text-white/60">
                <MessageCircle className="w-4 h-4 flex-shrink-0 text-green-500" />
                <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="hover:text-green-400 transition-colors text-sm">
                  +33 6 44 69 29 01
                </a>
              </li>
              <li className="flex items-start gap-3 text-white/60">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span className="text-sm">France entière<br />Formations sur site</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 sm:mt-16 pt-6 sm:pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs sm:text-sm text-center sm:text-left">
            © {currentYear} Académie IA. Tous droits réservés.
          </p>
          <p className="text-white/40 text-xs sm:text-sm flex items-center gap-2">
            Entièrement réalisé par l'Intelligence Artificielle avec 
            <a 
              href="https://emergent.sh" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#007AFF] hover:underline"
            >
              Emergent
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
